window.SiteReady(($) => {

  console.log('Init Block: Brochure');

  $('.js-brochure_item').on('swap:activate', (e) => {
    setTimeout(() => {
      let $target = $(e.currentTarget);

      window.scrollToElement( $target );
    }, 1);
  });

});